import classNames from "classnames";
import { ReactNode } from "react";

import Label from "../Label/Label";
import Prose from "../Prose/Prose";

import styles from "./Card.module.css";

const Card: React.FC<CardProps> = ({
  title,
  label,
  children,
  className,
  image,
  actions,
  contentAlign = "default",
}) => (
  <div
    className={classNames(styles.card, className, {
      [styles.contentLeft]: contentAlign === "left",
      [styles.contentRight]: contentAlign === "right",
    })}
  >
    {image && <div className={styles.image}>{image}</div>}
    <div className={styles.content}>
      {label && <Label className={styles.label}>{label}</Label>}
      <h3 className={styles.title}>{title}</h3>
      <Prose compact>{children}</Prose>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  </div>
);

export type CardProps = {
  children?: ReactNode;
  title: string;
  label?: string;
  className?: string;
  image: React.ReactNode;
  actions?: React.ReactNode;
  contentAlign?: "default" | "left" | "right";
};

export default Card;
